import { view } from '@yola/ws-sdk';
import helpers from 'src/js/modules/focal-point/helpers/index';

const getImageBounds = (imageNode, imageComputedStyles) => {
  const imageBoundsInIframe = view.accessors.getElementBoundsInIframe(imageNode);
  return helpers.calculateBoundsWithoutBorder(imageBoundsInIframe, imageComputedStyles);
};

export default getImageBounds;
